export default __webpack_public_path__ + "static/media/coyotepng.20bc5b36.png";